import { useCurrentOrg } from '@/app/entities/org/model'
import { createSupportRequestApiV1SupportSupportRequestsPost } from '@/common/api/client/sdk.gen'
import type {
    CreateSupportRequestApiV1SupportSupportRequestsPostData,
    CreateSupportRequestApiV1SupportSupportRequestsPostError,
    CreateSupportRequestApiV1SupportSupportRequestsPostResponse,
} from '@/common/api/client/types.gen'
import { useFormMutation } from '@/common/hooks/useFormMutation'

export const useSupport = () => {
    const { data: currentOrg } = useCurrentOrg()

    const { mutation, register, handleSubmit, errors, onSubmit, setError } = useFormMutation<
        CreateSupportRequestApiV1SupportSupportRequestsPostData['body'],
        CreateSupportRequestApiV1SupportSupportRequestsPostResponse,
        CreateSupportRequestApiV1SupportSupportRequestsPostError
    >({
        mutationFn: data =>
            createSupportRequestApiV1SupportSupportRequestsPost({
                body: {
                    ...data,
                    organization_id: currentOrg?.id ?? null,
                },
            }).then(r => r.data!),
        formOptions: {
            defaultValues: {
                subject: '',
                message: '',
            },
        },
        toastOptions: {
            successMessage: 'Запрос отправлен',
            errorMessage: 'Ошибка при отправке запроса',
        },
        clearOnSuccess: true,
        onError: () => {
            setError('root', { type: 'server', message: 'Ошибка при отправке запроса' })
        },
    })

    return {
        mutation,
        register,
        handleSubmit,
        errors,
        onSubmit,
    }
}
